import { Inject, Injectable, NgZone } from '@angular/core';
import { PortalNotificationChannel } from 'src/app/business/portal-notification/portal-notification-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { PortalNotificationModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class PortalNotificationSyncService extends SyncService<any> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<any>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(PortalNotificationModelName, appController, dispatcher, eventService, ngZone, platformSync);
    this.ignoreSync = true;
  }

  public canSync(channel: string): boolean {
    return channel === PortalNotificationChannel.CREATE;
  }
}
